import * as userManagementActions from './UserManagementActionTypes';

// Initial state for user management
const User_Management_State = {
    users: {}  // Initial state for users data
}

// User management reducer
export const userManagementReducer = (state = User_Management_State, action) => {
    switch (action.type) {
        case userManagementActions.GetUsersDataType:
            return{
                ...state,
                users: action.payload  // Update users data in the state
            };
        default:
            return state;
    }
}